/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { SddcQuotaPaginatedResponse } from '../model/sddcQuotaPaginatedResponse';
// @ts-ignore
import { SddcQuotaPatchSpec } from '../model/sddcQuotaPatchSpec';
// @ts-ignore
import { SddcQuotaPostSpec } from '../model/sddcQuotaPostSpec';
// @ts-ignore
import { SddcQuotaResponse } from '../model/sddcQuotaResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class BillingSddcQuotaOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Delete sddc quota by id
     * Delete sddc quota by id
     * @param sddcQuotaQueryIdRequired Sddc quota Primary Key
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSddcQuotaOperator(sddcQuotaQueryIdRequired: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<SddcQuotaResponse>;
    public deleteSddcQuotaOperator(sddcQuotaQueryIdRequired: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SddcQuotaResponse>>;
    public deleteSddcQuotaOperator(sddcQuotaQueryIdRequired: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SddcQuotaResponse>>;
    public deleteSddcQuotaOperator(sddcQuotaQueryIdRequired: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sddcQuotaQueryIdRequired === null || sddcQuotaQueryIdRequired === undefined) {
            throw new Error('Required parameter sddcQuotaQueryIdRequired was null or undefined when calling deleteSddcQuotaOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sddcQuotaQueryIdRequired, 'sddc-quota-query-id-required');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/sddc-quota`;
        return this.httpClient.request<SddcQuotaResponse>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all sddc quota by filters
     * Get all sddc quota by filter
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the sddc quota by this column
     * @param sddcQuotaOptionalQueryId Sddc quota Primary Key
     * @param vcfOrgId Linked VCF organization identifier in optional filter
     * @param startTsQueryOptional Start timestamp
     * @param endTsQueryOptional End timestamp
     * @param computedSddcHoursQueryOptional Computed sddc hours
     * @param usedSddcHoursQueryOptional Used sddc hours
     * @param effectiveSddcHoursQueryOptional Effective sddc hours
     * @param addedTsQueryOptional Added timestamp
     * @param usageUpdatedTsQueryOptional Usage updated timestamp
     * @param quotaUpdatedTsQueryOptional Quota updated timestamp
     * @param startTime Time at which query starts
     * @param endTime Time at which query ends
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSddcQuotaOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'vcfOrgId' | 'serviceType' | 'startTs' | 'endTs' | 'computedSddcHours' | 'usedSddcHours' | 'effectiveSddcHours' | 'addedTs' | 'usageUpdatedTs' | 'quotaUpdatedTs', sddcQuotaOptionalQueryId?: number, vcfOrgId?: string, startTsQueryOptional?: string, endTsQueryOptional?: string, computedSddcHoursQueryOptional?: number, usedSddcHoursQueryOptional?: number, effectiveSddcHoursQueryOptional?: number, addedTsQueryOptional?: string, usageUpdatedTsQueryOptional?: string, quotaUpdatedTsQueryOptional?: string, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<SddcQuotaPaginatedResponse>;
    public getSddcQuotaOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'vcfOrgId' | 'serviceType' | 'startTs' | 'endTs' | 'computedSddcHours' | 'usedSddcHours' | 'effectiveSddcHours' | 'addedTs' | 'usageUpdatedTs' | 'quotaUpdatedTs', sddcQuotaOptionalQueryId?: number, vcfOrgId?: string, startTsQueryOptional?: string, endTsQueryOptional?: string, computedSddcHoursQueryOptional?: number, usedSddcHoursQueryOptional?: number, effectiveSddcHoursQueryOptional?: number, addedTsQueryOptional?: string, usageUpdatedTsQueryOptional?: string, quotaUpdatedTsQueryOptional?: string, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SddcQuotaPaginatedResponse>>;
    public getSddcQuotaOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'vcfOrgId' | 'serviceType' | 'startTs' | 'endTs' | 'computedSddcHours' | 'usedSddcHours' | 'effectiveSddcHours' | 'addedTs' | 'usageUpdatedTs' | 'quotaUpdatedTs', sddcQuotaOptionalQueryId?: number, vcfOrgId?: string, startTsQueryOptional?: string, endTsQueryOptional?: string, computedSddcHoursQueryOptional?: number, usedSddcHoursQueryOptional?: number, effectiveSddcHoursQueryOptional?: number, addedTsQueryOptional?: string, usageUpdatedTsQueryOptional?: string, quotaUpdatedTsQueryOptional?: string, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SddcQuotaPaginatedResponse>>;
    public getSddcQuotaOperator(sortByOrder: 'ASC' | 'DESC', sortBy: 'id' | 'vcfOrgId' | 'serviceType' | 'startTs' | 'endTs' | 'computedSddcHours' | 'usedSddcHours' | 'effectiveSddcHours' | 'addedTs' | 'usageUpdatedTs' | 'quotaUpdatedTs', sddcQuotaOptionalQueryId?: number, vcfOrgId?: string, startTsQueryOptional?: string, endTsQueryOptional?: string, computedSddcHoursQueryOptional?: number, usedSddcHoursQueryOptional?: number, effectiveSddcHoursQueryOptional?: number, addedTsQueryOptional?: string, usageUpdatedTsQueryOptional?: string, quotaUpdatedTsQueryOptional?: string, startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getSddcQuotaOperator.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getSddcQuotaOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sddcQuotaOptionalQueryId, 'sddc-quota-optional-query-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vcfOrgId, 'vcf-org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startTsQueryOptional, 'start-ts-query-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endTsQueryOptional, 'end-ts-query-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>computedSddcHoursQueryOptional, 'computed-sddc-hours-query-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>usedSddcHoursQueryOptional, 'used-sddc-hours-query-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>effectiveSddcHoursQueryOptional, 'effective-sddc-hours-query-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>addedTsQueryOptional, 'added-ts-query-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>usageUpdatedTsQueryOptional, 'usage-updated-ts-query-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>quotaUpdatedTsQueryOptional, 'quota-updated-ts-query-optional');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startTime, 'start-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endTime, 'end-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/sddc-quota`;
        return this.httpClient.request<SddcQuotaPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch sddc quota by id
     * Find and patch sddc quota by id
     * @param sddcQuotaQueryIdRequired Sddc quota Primary Key
     * @param sddcQuotaPatchSpec Sddc quota patch spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchSddcQuotaOperator(sddcQuotaQueryIdRequired: number, sddcQuotaPatchSpec: SddcQuotaPatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<SddcQuotaResponse>;
    public patchSddcQuotaOperator(sddcQuotaQueryIdRequired: number, sddcQuotaPatchSpec: SddcQuotaPatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SddcQuotaResponse>>;
    public patchSddcQuotaOperator(sddcQuotaQueryIdRequired: number, sddcQuotaPatchSpec: SddcQuotaPatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SddcQuotaResponse>>;
    public patchSddcQuotaOperator(sddcQuotaQueryIdRequired: number, sddcQuotaPatchSpec: SddcQuotaPatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sddcQuotaQueryIdRequired === null || sddcQuotaQueryIdRequired === undefined) {
            throw new Error('Required parameter sddcQuotaQueryIdRequired was null or undefined when calling patchSddcQuotaOperator.');
        }
        if (sddcQuotaPatchSpec === null || sddcQuotaPatchSpec === undefined) {
            throw new Error('Required parameter sddcQuotaPatchSpec was null or undefined when calling patchSddcQuotaOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sddcQuotaQueryIdRequired, 'sddc-quota-query-id-required');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/sddc-quota`;
        return this.httpClient.request<SddcQuotaResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: sddcQuotaPatchSpec,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create sddc quota
     * Create new sddc quota entry
     * @param sddcQuotaPostSpec Sddc quota post spec
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postSddcQuotaOperator(sddcQuotaPostSpec: SddcQuotaPostSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<SddcQuotaResponse>;
    public postSddcQuotaOperator(sddcQuotaPostSpec: SddcQuotaPostSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SddcQuotaResponse>>;
    public postSddcQuotaOperator(sddcQuotaPostSpec: SddcQuotaPostSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SddcQuotaResponse>>;
    public postSddcQuotaOperator(sddcQuotaPostSpec: SddcQuotaPostSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sddcQuotaPostSpec === null || sddcQuotaPostSpec === undefined) {
            throw new Error('Required parameter sddcQuotaPostSpec was null or undefined when calling postSddcQuotaOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/sddc-quota`;
        return this.httpClient.request<SddcQuotaResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: sddcQuotaPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
